/**
 * Created by andy on 2019/5/10.
 */
import http from '@/http'

export default {
  /**
   * 收货数据列表
   * @param {number} page  页码
   * @param {Function} success 回调
   */
  list(page, success) {
    http.get('shipvessel/list', {
      page: page
    }, success);
  },
  /**
   * 收货数据检索
   * @param {number} page 页码
   * @param {string} key 关键词
   * @param {Function} success 回调
   */
  search(page, key, success) {
    http.get('shipvessel/search', {
      page: page,
      key: key
    }, success);
  }
}



// WEBPACK FOOTER //
// ./src/api/shipping/shipvessel.js